import EventsService from "services/EventsService";

const {createAsyncThunk , createSlice} = require("@reduxjs/toolkit");

export const getEvents = createAsyncThunk(
  "events/getAll/bo",
  async (_, { rejectWithValue }) => {
    try {
      const response = await EventsService.getEvents();
      return response.data.events || response.data.posts || [];
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Erreur");
    }
  }
);

export const getEventById = createAsyncThunk(
  "events/getEventById",
  async (id, { rejectWithValue }) => {
    try {
      const response = await EventsService.getEventById(id);
      // Handle both 'event' and 'post' response formats
      return response.data.event || response.data.post;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Erreur");
    }
  }
);

export const createEvent = createAsyncThunk(
  "events/createEvent",
  async (data, { rejectWithValue }) => {
    try {
      const response = await EventsService.createEvent(data);
      // Handle both 'event' and 'post' response formats
      return response.data.event || response.data.post;
    } catch (error) {
      return rejectWithValue(error.response?.data?.error || error.response?.data?.message || "Erreur");
    }
  }
);

export const updateEventById = createAsyncThunk(
  "events/updateEventById",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await EventsService.updateEvent(id, data);
      // Handle both 'event' and 'post' response formats
      return response.data.event || response.data.post;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message || "Erreur");
    }
  }
);

export const deleteEventById = createAsyncThunk(
  "events/deleteEventById",
  async (id, { rejectWithValue }) => {
    try {
      await EventsService.deleteEvent(id);
      return id;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Erreur");
    }
  }
);

const initialState = {
  events: [],
  event: null,
  loading: false,
  error: null,
};

const eventsSlice = createSlice({
  name: "events",
  initialState,
  reducers: {
    setEvents: (state, { payload }) => {
      state.events = payload;
    },
    setEvent: (state, { payload }) => {
      state.event = payload;
    },
    setLoading: (state, { payload }) => {
      state.loading = payload;
    },
    setError: (state, { payload }) => {
      state.error = payload;
    },
  },
  extraReducers: (builder) => {
    builder
      // Get All Events
      .addCase(getEvents.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getEvents.fulfilled, (state, { payload }) => {
        state.events = payload;
        state.loading = false;
        state.error = null;
      })
      .addCase(getEvents.rejected, (state, { payload }) => {
        state.error = payload;
        state.loading = false;
      })
      
      // Get Event By ID
      .addCase(getEventById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getEventById.fulfilled, (state, { payload }) => {
        state.event = payload;
        state.loading = false;
        state.error = null;
      })
      .addCase(getEventById.rejected, (state, { payload }) => {
        state.loading = false;
        state.error = payload;
      })
      
      // Create Event
      .addCase(createEvent.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createEvent.fulfilled, (state, { payload }) => {
        state.events.push(payload);
        state.loading = false;
        state.error = null;
      })
      .addCase(createEvent.rejected, (state, { payload }) => {
        state.loading = false;
        state.error = payload;
      })
      
      // Update Event
      .addCase(updateEventById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateEventById.fulfilled, (state, { payload }) => {
        // Update in the events array
        const index = state.events.findIndex((event) => event._id === payload._id);
        if (index !== -1) {
          state.events[index] = payload;
        }
        // Update current event if it's the one being edited
        if (state.event?._id === payload._id) {
          state.event = payload;
        }
        state.loading = false;
        state.error = null;
      })
      .addCase(updateEventById.rejected, (state, { payload }) => {
        state.loading = false;
        state.error = payload;
      })
      
      // Delete Event
      .addCase(deleteEventById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteEventById.fulfilled, (state, { payload }) => {
        state.events = state.events.filter((event) => event._id !== payload);
        state.loading = false;
        state.error = null;
      })
      .addCase(deleteEventById.rejected, (state, { payload }) => {
        state.loading = false;
        state.error = payload;
      });
  },
});

export const { setEvents, setEvent, setLoading, setError } =
  eventsSlice.actions;

export default eventsSlice.reducer;